var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendsSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 12.375C6.94689 12.375 7.5625 11.7594 7.5625 11C7.5625 10.2406 6.94689 9.625 6.1875 9.625C5.42811 9.625 4.8125 10.2406 4.8125 11C4.8125 11.7594 5.42811 12.375 6.1875 12.375Z",
    fill: "#00ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 12.375C16.5719 12.375 17.1875 11.7594 17.1875 11C17.1875 10.2406 16.5719 9.625 15.8125 9.625C15.0531 9.625 14.4375 10.2406 14.4375 11C14.4375 11.7594 15.0531 12.375 15.8125 12.375Z",
    fill: "#00ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.375C11.7594 12.375 12.375 11.7594 12.375 11C12.375 10.2406 11.7594 9.625 11 9.625C10.2406 9.625 9.625 10.2406 9.625 11C9.625 11.7594 10.2406 12.375 11 12.375Z",
    fill: "#00ACC5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.15,
    stroke: "#00ACC5",
    strokeWidth: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendsSearch);
export default __webpack_public_path__ + "static/media/pends_search.cafa30a31e903033e6a3a9d1548bfad8.svg";
export { ForwardRef as ReactComponent };